import i18n from "../../i18n";

export function SalesOrgIds() {
    return Object.freeze({
        SIMA: {
            "0133": {
                key: "0133",
                value: i18n.t('common.singapore')
            },
            "0135": {
                key: "0135",
                value: i18n.t('common.malaysia')
            },
            "0137": {
                key: "0137",
                value: i18n.t('common.brunei')
            }
        },
        PH: {
            "0111": {
                key: "0111",
                value: "0111"
            },
            "0112": {
                key: "0112",
                value: "0112"
            },
            "0114": {
                key: "0114",
                value: "0114"
            },
            "0113": {
                key: "0113",
                value: "0113"
            },
            "0118": {
                key: "0113",
                value: "0113"
            }
        },
        VN: {
            VN13: {
                key: "VN13",
                value: "VN13"
            },
            VN12: {
                key: "VN12",
                value: "VN12"
            },
            VN15: {
                key: "VN15",
                value: "VN15"
            },
            VN16: {
                key: "VN16",
                value: "VN16"
            },
            VN19: {
                key: "VN19",
                value: "VN19"
            },
            VN11: {
                key: "VN11",
                value: "VN11"
            },
            VN17: {
                key: "VN17",
                value: "VN17"
            }
        },
        CONA: {
            "4200": {
                key: "4200",
                value: "4200"
            },
            "4100": {
                key: "4100",
                value: "4100"
            },
            "4800": {
                key: "4800",
                value: "4800"
            },
            "5300": {
                key: "5300",
                value: "5300"
            },
            "4600": {
                key: "4600",
                value: "4600"
            },
            "4400": {
                key: "4400",
                value: "4400"
            }
        },
        FIJI: {
            "1000": {
                key: "1000",
                value: "1000"
            }
        },
        Tahiti: {
            "1000": {
                key: "1000",
                value: i18n.t('common.france')
            }
        }
    })
} 